export const getInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '';

  const first = words[0][0];
  const second = words.length > 1 ? words[words.length - 1][0] : words[0][1];

  return `${first}${second ?? ''}`.toUpperCase();
};

const MAX_DISPLAY_URL_LENGTH = 30;

export function cleanDisplayUrl(url: string): string {
  const cleaned = url
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '')
    .replace(/\?.*$/, '')
    .replace(/\/$/, '');

  return cleaned.length > MAX_DISPLAY_URL_LENGTH
    ? `${cleaned.slice(0, MAX_DISPLAY_URL_LENGTH - 1)}…`
    : cleaned;
}

export function formatPhoneNumber(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return phone;
}

type AnyObject = {
  [key: string]: any;
};

export function convertKeysToCamelCase(obj: any): any {
  const camelCaseKey = (key: string): string => {
    return key.replace(/_([a-z])/g, (_match, char) => char.toUpperCase());
  };

  if (Array.isArray(obj)) {
    return obj.map(item => convertKeysToCamelCase(item));
  }

  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  return Object.entries(obj).reduce<AnyObject>(
    (camelCaseObj, [key, value]) => ({
      ...camelCaseObj,
      [camelCaseKey(key)]:
        typeof value === 'object' && value !== null ? convertKeysToCamelCase(value) : value,
    }),
    {}
  );
}
